import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { getFormattedDate } from "shared/utils";
import QRCode from "react-qr-code";

import "./index.css";

interface ViewDetailsProps {
  item: IPackage;
  children?: React.ReactNode
}

export function ViewDetails({ item, children }: ViewDetailsProps) {
  return (
    <>
      <div className="flex col-12">
        <div className="col-8">
          <h1>{item.name}</h1>
          <span>Created on {getFormattedDate(item.createdAt, "d,m,y", "short")}</span>
        </div>
        <div className="col-4 flex justify-content-end align-items-center">
          <div
            className="flex align-items-center justify-content-center"
            style={{
              width: "100px",
              height: "100px",
              textAlign: "center",
              border: "1px solid black",
            }}
          >
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={item._id}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="col-6">
          <p>Seller Name:</p>
          <p>Seller Contact:</p>
          <p>Package Code:</p>
        </div>
        <div className="col-6 text-right">
          <p>{item.seller.name}</p>
          <p>{item.seller?.phoneNumber || "-"}</p>
          <p>{item.code}</p>
        </div>
      </div>
      {children ? <div className="col-12 pt-0">{children}</div> : null}
      <div className="flex my-2 px-2">
        <button className="print-details-button py-2 px-3 text-white cursor-pointer not-printable" onClick={() => {window.print()}}>Print Details</button>
      </div>
    </>
  );
}
